import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const COLS = [
  ["Shop", [["/shop", "All gear", "footer-shop-link"], ["/shop?category=apparel", "Apparel", "footer-apparel-link"], ["/shop?category=programs", "Training programs", "footer-programs-link"], ["/shop?category=supplements", "Supplements", "footer-supplements-link"], ["/shop?category=meals", "Meal plans", "footer-meals-link"]]],
  ["Help", [["/shipping-policy", "Shipping policy", "footer-shipping-link"], ["/returns", "Returns & refunds", "footer-returns-link"], ["/contact", "Contact us", "footer-contact-link"], ["/orders", "Track my order", "footer-orders-link"]]],
  ["Legal", [["/privacy", "Privacy policy", "footer-privacy-link"], ["/terms", "Terms of service", "footer-terms-link"]]],
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12 grid grid-cols-2 md:grid-cols-5 gap-10">
      <div className="col-span-2 space-y-4">
        <Logo />
        <p className="text-sm text-neutral-500 max-w-sm">Official merch of Awesome Body Sculpting. Built for the grind, worn with pride.</p>
        <p className="font-mono text-[11px] uppercase tracking-widest text-neutral-500">Free shipping on physical orders $75+ · Digital products delivered instantly</p>
      </div>
      {COLS.map(([title, links]) => (
        <div key={title}>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FF3B30] font-semibold mb-4">{title}</p>
          <ul className="space-y-2">
            {links.map(([to, label, id]) => (
              <li key={to}><Link to={to} data-testid={id} className="text-sm text-neutral-400 hover:text-white transition-colors">{label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-white/5">
      <p className="max-w-7xl mx-auto px-4 sm:px-8 py-5 font-mono text-xs text-neutral-600 uppercase tracking-widest">© {new Date().getFullYear()} ABS Gym · All rights reserved</p>
    </div>
  </footer>
);
